import React, { useState, useRef, useContext } from 'react';
import EmpresaContext from "../../../contexts/Empresa";
import { AxiosResponse } from 'axios';
import { useHistory } from "react-router-dom";
import api from "../../../services/api";
//@ts-ignore
import NotificationAlert from "react-notification-alert";
import Filters from './Filters'

import { Esteira } from '../../../entities/Marketing';

import Table from './Table';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
} from "reactstrap";
// core components
import SimpleHeader from '../../../components/Headers/SimpleHeader'

const Esteiras: React.FC = ({ }) => {

  const history = useHistory()
  const { empresaSelecionada } = useContext(EmpresaContext)
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState(null)
  const [esteiras, setEsteiras] = useState(new Array<Esteira>())
  const [pageProperties, setPageProperties] = useState({
    total: "0",
    perPage: 10,
    page: 1,
    lastPage: 1,
    loading: false
  })
  const [lastSearch, setLastSearch] = useState({})
  const notificationAlert = useRef<NotificationAlert>(null);

  function notify(type: string, msg: string) {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span data-notify="message">
            {msg}
          </span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 7
    };
    if(notificationAlert?.current) {
      notificationAlert.current.notificationAlert(options);
    }
  };

  function handleNewEsteira(e: React.MouseEvent) {
    e.preventDefault();
    history.push('esteiras/new')
  }

  async function updatePageProperties(response: AxiosResponse) {
    const { total, perPage, page, lastPage } = await response.data
    setPageProperties({
      total,
      perPage,
      page,
      lastPage,
      loading: false,
    })
  }

  async function loadEsteiras(page = 1,
    limit = 10,
    sortField = "nome",
    sortOrder = "asc",
    filters = lastSearch) {
    try {
      setPageProperties({
        ...pageProperties,
        loading: true
      })
      const response = await api.get(`common/empresas/${empresaSelecionada?.id}/esteiras/`, {
        params: {
          page,
          limit,
          sortField,
          sortOrder,
          ...filters
        }
      })
      setEsteiras(response.data.data)
      await updatePageProperties(response)
    } catch (error) {
      console.log(error.response)
      notify('danger', 'Houve um problema ao carregar esteiras.');
    }
  }

  async function handleTableChange(type: string, sortProperties: { page: number, sizePerPage: number, sortField: string, sortOrder: string }): Promise<void> {
    try {
      await loadEsteiras(
        sortProperties.page == 0 ? 1 : sortProperties.page,
        sortProperties.sizePerPage,
        sortProperties.sortField,
        sortProperties.sortOrder)
    } catch (error) {
      notify('danger', 'Houve um problema ao carregar personas.');
    }
  }


  return (
    <>
      {alert}
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <SimpleHeader name="Listagem de esteiras" parentName="Esteiras" />
      <div className="w-100">
        <Row>
          <Col>
            <Card>
              <CardHeader
                style={{
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
                }}>
                <Filters
                  title={<h1>Esteiras</h1>}
                  data={esteiras}
                  notify={notify}
                  presets={() => (
                    <Button
                      color="primary"
                      type="button"
                      onClick={handleNewEsteira}
                      size="sm">
                      <span className="btn-inner--icon">
                        <i className="ni ni-fat-add" />
                      </span>
                      Nova Esteira
                    </Button>
                  )}
                  actions={null}
                  load={(filters: object) => {
                    setLastSearch(filters)
                    loadEsteiras(
                      1,
                      10,
                      "nome",
                      "asc",
                      filters)
                  }}
                />
              </CardHeader>
              <CardBody>
                <Table
                  esteiras={esteiras || []}
                  notify={notify}
                  onTableChange={handleTableChange}
                  pageProperties={pageProperties}
                  loading={loading}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default Esteiras;